import React from 'react';
import "./Home.css";
import {Link} from 'react-router-dom';
import geoConnectBanner from '../../img/GeoConnect_Banner_otl.png'
import watcoLogo from '../../img/Watco_logo_vertical_Color.svg';

export default function Home() {
  const year = new Date().getFullYear();
  return (
    <div className="home">
      <section className='banner'>
        <img alt="geoconnect banner" src={geoConnectBanner} />
      </section>
      <section className='cards-container'>
        <section className='cards-sub-container'>
          <Link to='railcar-storage'>
            <div className='card raise-on-hover bg-white'>
              <div className='title'>Store Railcars</div>
              <div>Use the search tool and filters to find the location that fits your exact car storage needs.</div>
              <button className='action bg-yellow no-border'>Search Now</button>
            </div>
          </Link>
          <Link to='transloading'>
            <div className='card raise-on-hover bg-white'>
              <div className='title'>Locate Transloading, Material Handling &amp; Storage</div>
              <div>Identify a site based on location, transport mode, type of storage, and more.</div>
              <button className='action bg-yellow no-border'>Search Now</button>
            </div>
          </Link>
          <Link to='find-property'>
            <div className='card raise-on-hover bg-white'>
              <div className='title'>Find Property</div>
              <div>Watco has options at established sites such as industrial parks or terminal and port facilities, or yet-to-be-developed greenfield locations.</div>
              <div className='action bg-yellow no-border'>Search Now</div>
            </div>
          </Link>
        </section>
      </section>
      <footer>
        <div className="main-container">
          <div className="footer-bottom-block">
            <div className="footer-left-block">
              <div className="footer-logo">
                <a href="https://www.watco.com" className="footer-logo__link">
                  <img src={watcoLogo} height="72px" alt="logo" className="footer-logo__image" />
                </a>
              </div>
              <ul>
                <li>315 W 3rd St, Pittsburg, KS 66762</li>
                <li><a href="tel:620-231-2230">(620) 231-2230</a></li>
                <li>Emergency Rail Dispatch <a href="tel:316-262-1700">(316) 262-1700</a></li>
                <li>Safety and Ethics Hotline <a href="tel:866-479-2826">(866) 479-2826</a></li>
              </ul>
            </div>

            <div className="footer-column1-block">
              <ul className="header-menu__list">
                <li className="footer-menu__item has_dropdown-menu">
                  <a href="https://www.watco.com/about/">About</a>
                </li>
                <li className="footer-menu__item has_dropdown-menu">
                  <a href="https://www.watco.com/careers/">Careers</a>
                </li>
                <li className="footer-menu__item has_dropdown-menu">
                  <a href="https://www.watco.com/suppliers/">Suppliers</a>
                </li>
                <li className="footer-menu__item has_dropdown-menu">
                  <a href="https://www.watco.com/customer-tools/">Customer Tools</a>
                </li>
                <li className="footer-menu__item has_dropdown-menu">
                  <a href="https://www.watco.com/employment-verification/">Employment Verification</a>
                </li>
              </ul>

            </div>
            <div className="footer-column2-block">
              <ul className="header-menu__list">
                <li className="footer-menu__item has_dropdown-menu">
                  <a href="http://WatcoGear.com">Watco Gear</a>
                </li>
                <li className="footer-menu__item has_dropdown-menu">
                  <a href="/news/">News</a>
                </li>
                <li className="footer-menu__item has_dropdown-menu">
                  <a href="https://www.watco.com/privacy-policy/">Privacy Policy</a>
                </li>
                <li className="footer-menu__item has_dropdown-menu">
                  <a href="https://www.watco.com/investor-relations/">Investor Relations</a>
                </li>
                <li className="footer-menu__item has_dropdown-menu">
                  <a href="https://www.watco.com/giving-back/">Giving Back</a>
                </li>
              </ul>
            </div>

            <div className="footer-right-block">
              <a href="https://www.watco.com/system-map/" className="button-style-link map-link">System Map</a>
              <a href="https://watco.okta.com/" className="button-style-link login-link">Team Member Login</a>
              <p>As a transportation service company, Watco integrates rail, water, road, and air to solve any supply chain challenge.</p>
              <p className="copyright">Copyright © {year} </p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  )
}